import { blockRegistry } from "@okf/ootils";

/**
 * Auto-built from blockRegistry: every registered block with `contentBlockOption` defined
 * becomes an entry here. Order is determined by the registry.
 * qual_quant is derived from blockDef.qualQuant.
 */
const fromBlockRegistry = blockRegistry
    .getAll()
    .filter((b) => !!b.contentBlockOption)
    .map((b) => ({
        comp: b.compName,
        qual_quant: b.qualQuant,
        ...b.contentBlockOption,
    }));

/**
 * note that, currently some logic in the code assumes
 * variants would be single words like 'single' / 'multi'
 * as opposed to 'dropdown single' / 'dropdown multi'
 *
 * If we choose not to go with this sort of copy then,
 * code will have to be adjusted accordingly in :
 * BlockInSidebar > compNameToDisplay
 */

// ORDER MATTERS — registry-driven entries first, then unregistered fallbacks below
export const contentBlockOptions = [
    ...fromBlockRegistry,
    {
        display: 'TextInputs',
        variants: [
            { display: "Text", comp: "TextInput", icon: 'TextT', qual_quant: 'qual', directImportGroupsIdx: [2, 1] },
            { display: "Number", comp: "NumberInput", icon: 'Hash', qual_quant: 'quant', directImportGroupsIdx: [2, 4] },
            { display: "Email", comp: "EmailInput" },
            { display: "URL", comp: "URLInput", icon: 'LinkSimple', directImportGroupsIdx: [2, 3] },
            { display: "Phone", comp: "PhoneInput" },
        ]
    },
    { display: "Multi Select", comp: "CheckboxList", icon: 'CheckSquare', qual_quant: 'quant' },
    { display: "Single Select", comp: "RadioList", icon: 'RadioButton', iconWeight: 'fill', qual_quant: 'quant' },
    {
        display: 'Dropdowns',
        variants: [
            { display: 'Single', comp: 'DropdownSingle',  displayInDirectImportUI: 'Single Select', icon: 'RadioButton', iconWeight: 'fill', qual_quant: 'quant', directImportGroupsIdx: [2, 8]},
            { display: 'Multi', comp: 'DropdownMulti', displayInDirectImportUI: 'Multi Select', icon: 'CheckSquare', qual_quant: 'quant', directImportGroupsIdx: [2, 9] },
            { display: "Google Locations", comp: "DynamicRefetchDropdown" },
        ]
    },
    {
        display: 'TagsInputs',
        variants: [
            { display: "Single", comp: "TagsInputSingle", displayInDirectImportUI: 'Single Tags', icon: 'Tag', qual_quant: 'quant', directImportGroupsIdx: [3, 1] }, //variant1
            { display: "Multi", comp: "TagsInputMulti", displayInDirectImportUI: 'Multi Tags', icon: 'Tag', qual_quant: 'quant', directImportGroupsIdx: [3, 2] }, //variant2
            // { display: "Test", comp: "TagsInputMultiTest" }, //varianttest
        ]
    },
    {
        display: 'Date Pickers',
        variants: [
            { display: "Date (D/M/Y)", comp: "DatePicker", icon: 'CalendarBlank', qual_quant: 'quant', directImportGroupsIdx: [2, 5] }, //variant1
            { display: "Date Time Picker", displayInDirectImportUI: "Date & Time", comp: "DateTimePicker", icon: 'CalendarBlank', qual_quant: 'quant', directImportGroupsIdx: [2, 6] }, //variant1
            { display: "Date Range Picker", comp: "DateRangePicker", qual_quant: 'quant' }, //variant2
            { display: "Date Time Range Picker", comp: "DateTimeRangePicker", qual_quant: 'quant' }, //variant3
            //timepicker
            //timerangepicker
        ]
    },
    { display: "Title Input", comp: "TitleInput" },
    { display: "Subtitle Input", comp: "SubtitleInput" },
    { display: "Summary Input", comp: "SummaryInput" },
    
    { display: "Group Questions Input - Single Select", comp: "GroupQuestionsInputSingle", qual_quant: 'quant' },

    { display: "Image Input", comp: "ImageInput" },
    { 
        display: 'Repeaters',
        variants: [
            { display: 'List', comp: 'Repeater'},
            { display: 'Tabs', comp: 'RepeaterTabs'}
        ]
    },
    { display: "Simple Table", comp: "SimpleTable", icon: "Table", directImportGroupsIdx: [2, 7] },
    
    { display: "Video Input", comp: "VideoInput" },
    
    { display: "PPT Embed", comp: "IFrameInput" },
    { display: "JSON Input", comp: "JSONInput", icon: "Code", directImportGroupsIdx: [2, 10] },
    { display: "Link Embed With Input", comp: "LinkEmbedWithInput" },
    { display:"PDF Input",comp:"PDFInput" },
    { display: "Static Rich Text", comp: "StaticRichText" },
    
    
    { display: "Fragments Set", comp: "FragmentsSet" },
    { display: "Fragments Dict", comp: "FragmentsDict" },
   
    { display: 'Rich Text Editor (Deprecated)', comp: 'KPRichInput' },
    { display: 'Rich Text Editor 2 (Also Deprecated)', comp: 'RichTextEditor' }

]